export { default, emptyOtp, isOtpComplete, otpCode, OTP_DEFAULT_LENGTH } from './OtpInput';
export type { OtpInputColors, OtpInputProps } from './OtpInput';
